module.exports = __webpack_public_path__ + "img/564-705836.png";